import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../../utils';
import NodeActivityEditor from '../../NodeActivityEditor';
import CommentsIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import SneakPeakIcon from '../../../../public/assets/images/theme-2/icons/toolbar/visible-black.svg';
import { ViewSection, HeaderUserImage, HeaderUserName, HeaderRequestFeedback, SneakPeak } from '../styles';
import { EditorHeaderRowLeft, Editor, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';

const TaskContentTeacherPanel = ({ fileService, type, student, report, participations = [] }) => {
  const { name: studentName, image: studentImage } = student;
  const [hasPeaked, setHasPeaked] = useState(false);
  const headerName = type === 'group' ? i18n.__('editor_title_group') : studentName;

  if (!report) {
    if (type === 'group') {
      return (
        <ViewSection>
          <p>
            <i>{i18n.__('group_user_not_in_group')}</i>
          </p>
        </ViewSection>
      );
    } else {
      return null;
    }
  }

  const studentImages =
    type === 'group' ? (
      <>
        {participations.map((user) => {
          const { full_name, image, id } = user;
          return <HeaderUserImage key={id} src={getImageUrl(fileService, image, '60x60')} title={full_name} />;
        })}
      </>
    ) : (
      <HeaderUserImage src={getImageUrl(fileService, studentImage, '60x60')} title={studentName} />
    );

  const { uuid: entityId, state: reportState, type: entityType, body: reportBody, draft: reportDraft } = report;
  const workNotStarted = reportState === 'blank' || !reportBody;
  const workInProgress = reportState === 'active' && reportDraft;

  const toggleReportComments = () => {
    document.dispatchEvent(new CustomEvent('toggleComments', { detail: { entityId, entityType } }));
  };

  const sneakPeak = () => {
    setHasPeaked(true);
  };

  let editorContent = reportBody;
  if (workNotStarted) {
    editorContent = i18n.__('work_not_started');
  } else if (workInProgress && !hasPeaked) {
    editorContent = i18n.__('work_in_progress');
  }

  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        {studentImages}
        <HeaderUserName>{headerName}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight>
        <ImmersiveReaderButton />
        <HeaderRequestFeedback onClick={toggleReportComments} src={CommentsIcon} />
      </EditorHeaderRowRight>
    </>
  );

  const editorPanel = (
    <Editor
      className="content-section"
      data-selection-entity="taskreport"
      data-selection-uuid={report.uuid}
      showStatusText={workNotStarted || (workInProgress && !hasPeaked)}
      dangerouslySetInnerHTML={{ __html: editorContent }}
    />
  );

  const sneakPeakPanel =
    workInProgress && !hasPeaked ? (
      <SneakPeak onClick={sneakPeak} src={SneakPeakIcon}>
        {i18n.__('sneak_peak')}
      </SneakPeak>
    ) : null;

  return (
    <ViewSection>
      <NodeActivityEditor
        type={type}
        headerPanel={headerPanel}
        editorPanel={editorPanel}
        sneakPeakPanel={sneakPeakPanel}
      />
    </ViewSection>
  );
};

export default TaskContentTeacherPanel;

TaskContentTeacherPanel.propTypes = {
  fileService: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  student: PropTypes.object.isRequired,
  report: PropTypes.object,
  participations: PropTypes.array.isRequired,
};
